import axios from 'axios';
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_BASE_URL + '/auth/';

class AuthService {
    login(user) {
        return axios
            .post(API_URL + 'signin', {
                username: user.username,
                password: user.password
            })
            .then(response => {
                if (response.data.accessToken) {
                    localStorage.setItem('user', JSON.stringify(response.data));
                }

                return response.data;
            });
    }

    logout() {
        localStorage.removeItem('user');
    }

    register(user) {
        return axios.post(API_URL + 'signup', {
            username: user.username,
            email: user.email,
            password: user.password
        });
    }

    getAllRoles(){
        return axios.get(API_URL + 'roles', { headers: authHeader() });
    }

    setRole(role){
        return axios.post(API_URL + 'roles/assign', {
            role
        }, {headers: authHeader()})
    }

    getAllUser(){
        return axios.get(API_URL + 'users', { headers: authHeader() });
    }
}

export default new AuthService();